(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elora-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elora-announcement')) {
    customElements.define('elora-announcement', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const track = this.querySelector('.el-ann__track');
        if (!track || track.children.length < 2) return;
        this.setAttribute('data-ready', '');
        const move = direction => {
          const current = Math.round(track.scrollLeft / track.clientWidth);
          const next = (current + direction + track.children.length) % track.children.length;
          track.scrollTo({left:next * track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        this.querySelector('[data-el-ann-prev]').addEventListener('click', () => move(-1), {signal:this.controller.signal});
        this.querySelector('[data-el-ann-next]').addEventListener('click', () => move(1), {signal:this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
